// @ts-nocheck
import React from "react";
import style from "./ChangePlan.module.scss";
import PropTypes from "prop-types";
import { SecondaryBtn } from "../../common/Payment/SecondaryBtn";
import { InfoBtn } from "../../common/Payment/InfoBtn";
import { useTranslation } from "react-i18next";

export const ChangeFreePlanModalBody = ({
  afterPlanInfo,
  updatePlanErrMessage,
  isLoading,
  handleClose,
  updatePlan,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={style.changePlanModalWrap} data-testid="test-change-plan-modal">
        <div className={style.changePlanModalTitle}>{t("ChangeFreePlanModalBody.プラン変更申し込み")}</div>
        <div className={style.changePlanModalDescription}>
          {t("ChangeFreePlanModalBody.フリープランへの変更は")}
          <span className={style.changePlanModalDescriptionBold}>
            {t("ChangeFreePlanModalBody.次回更新日より適用")}
          </span>
          {t("ChangeFreePlanModalBody.されます。")}
          <div style={{ padding: "15px 0px" }}>
            {t("ChangeFreePlanModalBody.下記ご注意をお願いいたします。")}
            <div className={style.changePlanModalDescriptionBold}>
              {t("ChangeFreePlanModalBody.・有料プランで提供している機能等は自動的にご利用できなくなります")}
            </div>
            <div className={style.changePlanModalDescriptionBold}>
              {t(
                "ChangeFreePlanModalBody.・ライセンス数・データベース数・フローボット数等がフリープランの制限を超えている場合、削除するまで正常にご利用いただけないことがございます。",
              )}
            </div>
          </div>
          {t("ChangeFreePlanModalBody.内容に問題がない場合は、申し込むをクリックしてください。")}
        </div>

        <div className={style.changePlanModalContent}>
          <div className={style.changePlanModalItemContainer}>
            <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
              <span className={style.changePlanName}>{afterPlanInfo?.plan_name}</span>
            </div>
            <div className={style.changePlanModalItemWrap}>
              <div className={style.changePlanModalItem}>
                <div className={style.changePlanModalBasicPriceTitle}>{t("ChangeFreePlanModalBody.基本月額料金")}</div>
                <div className={style.changePlanModalBasicPriceValueWrap}>
                  <div className={style.changePlanModalBasicPriceValueItem}>
                    <div className={style.changePlanModalBasicPriceValue}>{t("ChangeFreePlanModalBody.無料")}</div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "0px",
                  alignSelf: "stretch",
                  border: "1px rgba(10, 105, 130, 0.08) solid",
                }}
              />
              <div className={style.changePlanModalItem}>
                <div className={style.changePlanModalBasicPriceTitle}>
                  {t("ChangeFreePlanModalBody.月間タスク実行上限")}
                </div>
                <div className={style.changePlanModalBasicPriceValue}>{afterPlanInfo?.task_count}</div>
              </div>
              <div
                style={{
                  width: "0px",
                  alignSelf: "stretch",
                  border: "1px rgba(10, 105, 130, 0.08) solid",
                }}
              />
              <div className={style.changePlanModalItem}>
                <div className={style.changePlanModalBasicPriceTitle}>{t("ChangeFreePlanModalBody.ライセンス")}</div>
                <div className={style.changePlanModalBasicPriceValueWrap}>
                  <div className={style.changePlanModalBasicPriceValueItem}>
                    <div className={style.changePlanModalBasicPriceValue}>{afterPlanInfo?.license_count}</div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ paddingTop: "16px" }}>
              <div style={{ display: "flex", flexDirection: "row", gap: "12px", alignItems: "center" }}>
                <span style={{ color: "#777777", fontSize: "12px", fontWeight: "300" }}>
                  {t("ChangeFreePlanModalBody.適用日")}
                </span>
                <span style={{ color: "#777777", fontSize: "14px", fontWeight: "400" }}>
                  {afterPlanInfo?.start_date}
                </span>
              </div>
            </div>
          </div>
        </div>
        <>
          {updatePlanErrMessage.length ? (
            <div className={style.updatePlanErr}>
              {updatePlanErrMessage.map((errMessage, i) => (
                <div key={i}>{errMessage}</div>
              ))}
            </div>
          ) : (
            <></>
          )}
        </>
        <div className={style.changePlanModalButtonWrap}>
          <SecondaryBtn
            text={t("ChangeFreePlanModalBody.キャンセル")}
            disabled={false}
            className={`test-force-upgrade ${style.changePlanModalButton}`}
            submit={() => handleClose()}
            style={{ color: "#222222" }}
          />
          <div data-testid="apply-button">
            <InfoBtn
              text={t("ChangeFreePlanModalBody.申し込む")}
              loading={isLoading}
              className={`test-force-upgrade ${style.changePlanModalButton}`}
              submit={() => updatePlan()}
            />
          </div>
        </div>
      </div>
    </>
  );
};

ChangeFreePlanModalBody.propTypes = {
  afterPlanInfo: PropTypes.object,
  updatePlanErrMessage: PropTypes.array,
  isLoading: PropTypes.bool,
  handleClose: PropTypes.func,
  updatePlan: PropTypes.func,
};
